import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  container: {
    right: "12px",
    top: "12px",
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "8px",
    width: "50vw",
    height: "calc(100vh - 24px)",
    overflowX: "hidden",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    fontFamily: "Manrope !important",
    "@media (max-width: 1220px)": {
      width: "60vw",
    },
    "@media (max-width: 985px)": {
      width: "70vw",
    },
    "@media (max-width: 820px)": {
      width: "calc(100vw - 24px)",
    },
  },

  header: {
    backgroundColor: "#EDF5FB",
    position: "fixed",
    height: "80px",
    width: "50vw",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    padding: "0px 24px",
    "@media (max-width: 1220px)": {
      width: "60vw",
    },
    "@media (max-width: 985px)": {
      width: "70vw",
    },
    "@media (max-width: 820px)": {
      width: "calc(100vw - 24px)",
    },
  },
  title: {
    color: "#308CDB",
    fontWeight: 700,
    fontFamily: "Manrope",
    fontSize: "17px",
  },
  closeContainer: {
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    backgroundColor: "#FFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#308CDB",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.05)",
    },
  },
  closeIcon: {
    marginTop: "6px",
  },

  content: {
    overflowY: "auto",
    height: "calc(100vh - 104px)",
    marginTop: "80px",
    display: "block",
    "&::-webkit-scrollbar": {
      width: "8px",
      borderTopRightRadius: "8px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#D1E9FF",
      borderTopRightRadius: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#84CAFF",
      borderRadius: "8px",
    },
  },
  groupSection: {},
  groupInformation: {
    backgroundColor: "#F9FAFB",
    padding: "0px 24px",
    minHeight: "52px",
    "@media (max-width: 515px)": {
      padding: "8px 24px",
    },
  },
  groupName: {
    color: "#465869",
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "16px",
  },
  groupNameInput: {
    minWidth: "150px",
  },
  groupNameEdit: {
    flexWrap: "nowrap",
    "@media (max-width: 515px)": {
      flexWrap: "wrap",
    },
  },
  groupSaveOrCancel: {
    display: "flex",
    alignItems: "center",
  },
  groupActions: {
    display: "flex",
    alignItems: "center",
  },

  emptyGroup: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "24px",
  },
  empttyGroupMessage: {
    color: "#465869",
    fontWeight: 700,
    fontSize: "16px",
    padding: "40px 0px",
  },
  emptyGroupImage: {
    marginLeft: "18px",
  },

  serviceSection: {
    padding: "0px 24px",
  },
  serviceLabelContainer: {
    margin: "24px 0px 16px 0px",
  },
  serviceLabel: {
    color: "#465869",
    fontWeight: 700,
    fontSize: "15px",
  },
  serviceTable: {
    width: "calc(50vw - 32px)",
    paddingRight: "24px",
    marginBottom: "24px",
    "@media (max-width: 1220px)": {
      width: "calc(60vw - 32px)",
    },
    "@media (max-width: 985px)": {
      width: "calc(70vw - 32px)",
    },
    "@media (max-width: 820px)": {
      width: "calc(100vw - 64px)",
    },
  },
  serviceEmpty: {
    color: "#F97066",
    fontSize: "14px",
    fontWeight: "bold",
  },

  statusBadge: {
    padding: "0px 10px",
    paddingTop: "1px",
    borderRadius: "20px",
    height: "24px",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "20px",
    color: "#FFF !important",
  },

  groupBadgeActive: {
    background: "#38CFC4 !important",
  },
  groupBadgeInactive: {
    background: "#F97066 !important",
  },

  serviceBadge: {
    heigt: "32px !important",
  },
  serviceBadgeActive: {
    background: "#D1FADF !important",
    border: "1px solid #D1FADF",
    color: "#32D583 !important",
  },
  serviceBadgeInactive: {
    background: "#FEE4E2 !important",
    border: "1px solid #FEE4E2",
    color: "#F97066 !important",
  },

  icon: {
    cursor: "pointer",
    marginRight: "12px",
    color: "#475467",
    marginTop: "8px",
  },

  groupListSkeleton: {
    height: "104px",
    marginTop: "12px",
  },
  groupItemSkeleton: {},
}));

export const skeletonStyles = (variables: { height: number | string }) =>
  makeStyles({
    skeleton: {
      height: variables.height,
    },
  });

export default styles;
